// Module
var code = `<breadcrumbs></breadcrumbs>
<center-header center="\$ctrl.center"></center-header>
<section class="box">
  <sub-header header="'Center groups'"></sub-header>

  <table ng-if="this.groups.length !== 0" class="table">
    <thead>
    <tr>
      <th>No.</th>
      <th>Group Name</th>
      <th>Group No.</th>
      <th>Mother Branch</th>
      <th>Total active loans</th>
      <th>Total loans</th>
      <th>Total outstanding principal balance</th>
      <th>Group fund savings</th>
      <th>&nbsp;</th>
    </tr>
    </thead>

    <tbody>
    <tr ng-repeat="group in \$ctrl.groups" class="table__row">
      <td>{{\$index + 1}}</td>
      <td>{{group.name}}</td>
      <td>{{group.customerId}}</td>
      <td>{{group.motherBranchName}}</td>
      <td>{{group.totalActiveLoansCount}} loan{{group.totalActiveLoansCount === 1 ? '' : 's'}}</td>
      <td>{{group.totalLoansCount}} loan{{group.loans.length === 1 ? '' : 's'}}</td>
      <td>{{group.totalPrincipalBalance | nxCurrency}}</td>
      <td>{{group.groupFundSavings | nxCurrency}}</td>
      <td>
        <button
          ng-click="\$ctrl.openTransferModal(\$event, group)"
          type="button"
          class="btn btn-warning"
          command-access="TransferCustomerGroupToAnotherCenter"
        >
          Transfer
        </button>
        <button
          ng-click="\$ctrl.remove(\$event, group)"
          type="button"
          class="btn btn-danger"
          command-access="RemoveCustomerGroupInCenter"
        >
          Remove
        </button>
        <button
          ng-click="\$ctrl.open(\$event, group)"
          type="button"
          class="btn btn-primary"
        >
          Open
        </button>
      </td>
    </tr>

    <tr>
      <td></td>
      <td class="labels" colspan="8">
        <center-group-picker
          on-add="\$ctrl.add"
          on-transfer-here="\$ctrl.transferHere"
          filter-result="\$ctrl.filterGroupPickerResult"
          disabled="\$ctrl.center && !\$ctrl.center.active"
        ></center-group-picker>
      </td>
    </tr>
  </table>
</section>

<modal on-api-ready="\$ctrl.onTransferModalApiReady" hide-footer="true">
  <modal-header>
    <h3>Transfer customer group [{{\$ctrl.transferGroup.name}}] to another center</h3>
  </modal-header>
  <modal-body>
    <div class="center-search">
      <center-picker
        on-choose="\$ctrl.transfer"
        filter-result="\$ctrl.filterCenterPickerResult"
        button-label="'Transfer'"
      ></center-picker>
    </div>
  </modal-body>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/center/groups/center-groups.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;